import {createFileRoute} from '@tanstack/react-router';
import {z} from 'zod';
import FeedbackLandingPage from '../../../../pages/FeedbackLandingPage';

const feedbackSearchSchema = z.object({
  zoomUserId: z.string().optional(),
});

export const Route = createFileRoute(
  '/_authenticated/courses/$courseId/feedback',
)({
  validateSearch: feedbackSearchSchema,
  component: function CourseFeedbackRoute() {
    const {courseId} = Route.useParams();
    const {zoomUserId} = Route.useSearch();
    return (
      <FeedbackLandingPage
        courseId={courseId}
        zoomUserIdFromSearch={zoomUserId}
      />
    );
  },
});
